import _ from 'lodash'
import { useLocation } from 'react-router'
import { useSelector } from 'react-redux'

import { getCmsLoginUrl } from '../redux/config'
import { DISABLED_LOGIN_CALLBACK_ROUTES } from '../routes/routes'
import { formatPath } from '../utils/routes'

import { useMatchRoute } from './useMatchRoute'

export function useLoginUrl() {
  const location = useLocation()
  const { matchRoute } = useMatchRoute()
  const loginUrl = useSelector(getCmsLoginUrl)

  if (_.isEmpty(loginUrl)) return '/'

  return formatPath(loginUrl, {
    returnUrl: _.some(DISABLED_LOGIN_CALLBACK_ROUTES, x => !!matchRoute(location.pathname, x))
      ? undefined
      : window.location.href
  })
}
